import { ID, idDef } from "@kosmod/kit";
import { s, Shape } from "@kosmod/pancake";
import { TheatreVector3, TheatreVector4 } from "./vector";

export type SurfaceID = ID<"surface", true>;
export const SurfaceID = s.ref<SurfaceID>()(idDef);

export const Surface = s.u([
  s.o({
    type: s.lu(['square-grid', 'hex-grid', 'no-grid']),
    id: SurfaceID,
    position: TheatreVector3,
    rotation: TheatreVector4,
  }),
  s.o({
    type: s.l('patch'),
    id: SurfaceID,
  }),
  s.o({
    type: s.l('freeroam'),
    id: SurfaceID,
  }),
]);

export type Surface = Shape.Type.Of<typeof Surface>;